import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { EditClub } from '../actions/clubs-search.actions';
import { ClubsTabState } from '../models/clubs.models';

const initialState: ClubsTabState = {
  tabIndex: 0,
};

export const ClubsTabReducer = createReducer(
  initialState,
  on(EditClub, (state) => ({
    ...state,
    tabIndex: 1,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) => {
    if (activeComponent === 'ClubsCreateNewComponent') return { ...state, tabIndex: 1 };
    else return initialState;
  }),
);
